import { render, staticRenderFns } from "./MinimumUpdateProfile.vue?vue&type=template&id=9f8e2424&scoped=true&"
import script from "./MinimumUpdateProfile.vue?vue&type=script&lang=ts&"
export * from "./MinimumUpdateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./MinimumUpdateProfile.vue?vue&type=style&index=0&id=9f8e2424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e2424",
  null
  
)

export default component.exports